import {useDispatch} from "react-redux";
import {clearForm, clearView, setSaveUserError} from "../slices/usersSlice";
import {setEditRestaurantFormActive, setNewRestaurantFormActive} from "../slices/restaurantSlice";
import {clearProfileForm} from "../slices/userProfileSlice";
import {setCmsInEditMode, setDashboardInEditMode} from "../slices/globalParamsSlice";

export const useClearDashboardState = () => {
    const dispatch = useDispatch();
    return () => {
        dispatch(clearForm());
        dispatch(clearView());
        dispatch(clearProfileForm());
        dispatch(setEditRestaurantFormActive(false));
        dispatch(setNewRestaurantFormActive(false));
        dispatch(setSaveUserError(null));
        dispatch(setDashboardInEditMode(false));
        dispatch(setCmsInEditMode(false));
    };
}